export default __webpack_public_path__ + "static/media/blog-30-thumbnail.f39d4a7b.png";